var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCupTogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 64H416L392.875 17.75C387.375 6.875 376.375 0 364.25 0H83.75C71.625 0 60.625 6.875 55.125 17.75L32 64H16C7.125 64 0 71.125 0 80V112C0 120.875 7.125 128 16 128H432C440.875 128 448 120.875 448 112V80C448 71.125 440.875 64 432 64ZM106.75 512H341.25C357.875 512 371.75 499.25 373.125 482.625L400 160H48L74.875 482.625C76.25 499.25 90.125 512 106.75 512ZM327.75 256L314.5 416H133.5L120.25 256H327.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupTogo);
export default __webpack_public_path__ + "static/media/cup-togo.3c12951c6b29b0bf3f595ea101e82aae.svg";
export { ForwardRef as ReactComponent };